import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../components/Component";

const WorkExecutionAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Execution</span>
            <span className="sub-text">
              Manage work execution updates, approvals, and progress tracking
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-under-execution`}
              onClick={() => updateSm(false)}
            >
              <Icon name="edit" />
              <span>Update Work Execution</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-pending-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-closed-works`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle-fill" />
              <span>Closed Works (Approved)</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkExecutionAside;